// extracted by mini-css-extract-plugin
export default {"deleteLinkedAccount":"page_deleteLinkedAccount__xqZ1V","social":"page_social__1mrJO","socialButtons":"page_socialButtons__nzfyJ","businessEmail":"page_businessEmail__ZelCc"};